import { organizationActionType } from '../../constants/index';

const initialState = {
    organizationsAll: [],
    loading: false,
    error: null
};

const organizationReducer = (state = initialState, action) => {
    switch (action.type) {
        case organizationActionType.FETCH_ORGANIZATIONS_ALL:
            return {
                ...state,
                organizationsAll: action.payload,
                loading: false
            };
        case organizationActionType.FETCH_ORGANIZATIONS_SUCCESS:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};

export default organizationReducer; 